import * as Sentry from "@sentry/react";
import { useMemoizedFn } from "ahooks";
import { useEffect } from "react";

type CaptureContext = Parameters<typeof Sentry.captureException>[1];

/** Reports a query error once per distinct error, instead of on every render while the query stays failed. */
export const useCaptureQueryError = (error: Error | null | undefined, context: CaptureContext) => {
    const captureError = useMemoizedFn((queryError: Error) => {
        Sentry.captureException(queryError, context);
    });

    useEffect(() => {
        if (!error) {
            return;
        }

        captureError(error);
    }, [error, captureError]);
};
